import React from 'react';
import { Link } from 'react-router-dom';

const baseStyles = "px-6 py-3 rounded-lg font-semibold transition-all duration-300 ease-in-out transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2";

const variantStyles = {
  primary: "bg-indigo-600 text-white hover:bg-indigo-500 focus:ring-indigo-500 disabled:opacity-60 disabled:transform-none disabled:cursor-not-allowed",
  secondary: "bg-slate-200 text-slate-800 hover:bg-slate-300 focus:ring-slate-400 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600 dark:focus:ring-slate-500 disabled:opacity-60 disabled:transform-none disabled:cursor-not-allowed",
};

// Aceptamos '...props' para capturar cualquier atributo extra (como type="button" o disabled)
const Button = ({ to, href, onClick, children, variant = 'primary', className = '', ...props }) => {
  const styles = `${baseStyles} ${variantStyles[variant]} ${className}`;

  if (to) {
    // Los Links de React Router no necesitan 'type', por lo que no es necesario pasar ...props
    return <Link to={to} className={styles}>{children}</Link>;
  }
  
  if (href) {
    // Las etiquetas <a> sí pueden tener atributos como 'download', etc.
    return <a href={href} target="_blank" rel="noopener noreferrer" className={styles} {...props}>{children}</a>;
  }

  // La magia está aquí: {...props} pasa 'type', 'disabled', o cualquier otro atributo HTML
  return (
    <button onClick={onClick} className={styles} {...props}>
      {children}
    </button>
  );
};

export default Button;